import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FiMenu,
  FiX,
  FiHome,
  FiPackage,
  FiMap,
  FiGrid,
  FiList,
  FiUsers,
  FiClock,
  FiLogOut,
} from 'react-icons/fi';
import logoOgpBlanc from '../assets/ogp-logo-blanc.png';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  // Fermer la sidebar quand on change de page
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Empêcher le scroll du body quand la sidebar est ouverte
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleLogout = async () => {
    await logout();
  };

  const navItems = [
    { path: '/', label: 'Tableau de Bord', icon: FiHome },
    { path: '/immobilisations', label: 'Immobilisations', icon: FiPackage },
    { path: '/carte', label: 'Carte', icon: FiMap },
    { path: '/scan', label: 'Scanner QR', icon: FiGrid },
    { path: '/qr-generator', label: 'Generer QR', icon: FiGrid },
    { path: '/categories', label: 'Catégories', icon: FiList },
    { path: '/services', label: 'Services', icon: FiList },
    ...(user?.role === 'admin' ? [{ path: '/users', label: 'Utilisateurs', icon: FiUsers }] : []),
    { path: '/historique', label: 'Historique', icon: FiClock },
  ];

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
      >
        {isOpen ? <FiX size={22} /> : <FiMenu size={22} />}
      </button>

      {/* Dark Overlay (mobile) */}
      <div
        className={`sidebar-overlay ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(false)}
      />

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <Link to="/" className="sidebar-logo" onClick={() => setIsOpen(false)}>
            <img src={logoOgpBlanc} alt="OGP" className="sidebar-logo-img" />
            <span>OGP IMMO</span>
          </Link>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => setIsOpen(false)}
              >
                <Icon className="nav-icon" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <Link to="/profil" className="user-info" onClick={() => setIsOpen(false)} title="Mon profil">
            <div className="user-avatar">
              {(user?.prenom || user?.email || '?').charAt(0)?.toUpperCase()}
            </div>
            <div className="user-details">
              <h6>{user?.prenom} {user?.nom}</h6>
              <p>{user?.role === 'admin' ? 'Administrateur' : user?.role === 'agent' ? 'Agent' : 'Consultation'}</p>
            </div>
          </Link>
          <button
            onClick={handleLogout}
            className="btn btn-ghost"
            style={{
              width: '100%',
              marginTop: '1rem',
              color: 'var(--secondary-color)',
              borderColor: 'var(--secondary-color)',
            }}
          >
            <FiLogOut />
            Déconnexion
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
